module.exports = __webpack_public_path__ + "assets/img/car19.bb2f77b9.jpg";